<template>
    <div>
        <Card>
            <Card>
                <p slot="title">{{t.ad.searchName}}</p>
                <Form :model="formItem" :label-width="110" label-position="right">
                    <Row :gutter="16">
                        <Col span="6">
                            <Form-item :label="t.ad.spaceName">
                                <Select v-model="formItem.spaceId" clearable style="width: 100% !important"
                                        :placeholder="msgUtil.placeholderSelected(t.ad.spaceName)">>
                                    <Option v-for="adSpace in adSpaceList" :value="adSpace.id" :key="adSpace.id">
                                        {{ adSpace.name }}
                                    </Option>
                                </Select>
                            </Form-item>
                        </Col>
                        <Col span="6">
                            <Form-item :label="t.ad.name">
                                <Input v-model="formItem.name"
                                       :placeholder="msgUtil.placeholderRequired(t.ad.name)"></Input>
                            </Form-item>
                        </Col>
                        <Col span="6">
                            <Form-item :label="t.ad.pattern">
                                <Select v-model="formItem.pattern" clearable style="width: 100% !important"
                                        :placeholder="msgUtil.placeholderSelected(t.ad.pattern)">>
                                    <Option value="0">{{t.ad.pDay}}</Option>
                                    <Option value="1">{{t.ad.pHits}}</Option>
                                </Select>
                            </Form-item>
                        </Col>
                        <Col span="6">
                            <Form-item :label="t.ad.status">
                                <Select v-model="formItem.status" clearable style="width: 100% !important"
                                        :placeholder="msgUtil.placeholderSelected(t.ad.status)">>
                                    <Option value="1">{{t.ad.open}}</Option>
                                    <Option value="0">{{t.ad.close}}</Option>
                                </Select>
                            </Form-item>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="24">
                            <Button type="primary" icon="ios-search" style="float:right" @click="search(true)">
                                {{msgUtil.message.action.search}}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Row class="margin-top-10">
                <Col span="12">
                    <sort-button-group :buttons="sortButton" @on-order="orderClick"/>
                </Col>
                <Col style="text-align:right;" span="12">
                    <!-- name 是路由名，参考的@/router/organization/dept.js的名 -->
                    <Button icon="md-add" to="./add">{{msgUtil.message.action.add}}</Button>
                    <Button icon="ios-trash" @click="delAll">{{msgUtil.message.action.deleteAll}}</Button>
                </Col>
            </Row>
            <Row class="margin-top-10">
                <Table ref="selection" :context="self" :columns="columns" :data="data" :loading="loading"
                       @on-selection-change="rowSelect"></Table>
            </Row>
            <Row class="margin-top-10" type="flex" justify="end">
                <Page ref="page" :total="total" show-total show-sizer @on-change="pageChange"
                      @on-page-size-change="pageSizeChange">
                    {{msgUtil.message.page.total}} {{ total }} {{msgUtil.message.page.paper}}
                </Page>
            </Row>
        </Card>
    </div>
</template>

<script>
import { Message } from 'iview';
import { del, delAll, getAdSpaceList, getList } from '@/api/ad';
import sortButtonGroup from '@/components/sort-button-group.vue';

export default {
    name: 'content_ad_list',
    components: {
        sortButtonGroup,
    },
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        const renderName = (h, params) => {
            const row = params.row;
            return h('div', [
                h(
                    'router-link',
                    {
                        props: {
                            to: './detail/' + row.id,
                        },
                    },
                    row.name
                ),
            ]);
        };
        const renderSortOrder = (h, params) => {
            const row = params.row;
            return h(
                'Tag',
                {
                    props: {
                        type: 'border',
                    },
                },
                row.sortOrder
            );
        };
        const renderPattern = (h, params) => {
            const row = params.row;
            const color = row.pattern === '0' ? 'volcano' : 'magenta';
            const text = row.pattern === '0' ? t.ad.pDay : t.ad.pHits;
            return h(
                'Tag',
                {
                    props: {
                        type: 'border',
                        color: color,
                    },
                },
                text
            );
        };
        const renderStatus = (h, params) => {
            const row = params.row;
            const color = row.status === '0' ? 'error' : row.status === '1' ? 'success' : 'error';
            const text = row.status === '0' ? t.ad.close : row.status === '1' ? t.ad.open : t.ad.close;
            return h(
                'Tag',
                {
                    props: {
                        type: 'border',
                        color: color,
                    },
                },
                text
            );
        };
        const renderAction = (h, params) => {
            const row = params.row;
            return h('button-group', [
                h(
                    'i-button',
                    {
                        props: {
                            type: 'primary',
                            size: 'small',
                            to: './edit/' + row.id,
                        },
                    },
                    msgUtil.message.action.edit
                ),
                h(
                    'i-button',
                    {
                        props: {
                            type: 'error',
                            size: 'small',
                            style: 'margin-left:5px',
                        },
                        on: {
                            click: this.del.bind(this, row.id),
                        },
                    },
                    msgUtil.message.action.delete
                ),
            ]);
        };
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            // 排序btn
            sortButton: [
                { key: 'sortOrder', value: t.ad.sortOrder, order: 0 },
                { key: 'pattern', value: t.ad.pattern, order: 0 },
                { key: 'status', value: t.ad.status, order: 0 },
                { key: 'createTime', value: t.ad.createTime, order: 0 },
            ],
            // 入力条件
            formItem: {
                id: '',
                name: '',
                spaceId: '',
                spaceName: '',
                pattern: '',
                hits: '',
                patternHits: '',
                startTime: '',
                endTime: '',
                sortOrder: 0,
                createTime: '',
                status: '',
                oa: '',
                od: '',
                current: 1,
                size: 10,
            },
            data: [],
            total: 0,
            selectIds: [],
            adSpaceList: [],
            columns: [
                { title: '', type: 'selection', align: 'center', width: 44 },
                { title: t.table.id, key: 'id', align: 'center', width: 164 },
                { title: t.table.spaceName, key: 'spaceName', align: 'center', width: 180, tooltip: true },
                { title: t.table.name, key: 'name', width: 180, tooltip: true, render: renderName },
                { title: t.table.pattern, key: 'pattern', width: 110, render: renderPattern },
                { title: t.table.startTime, key: 'startTime', width: 150 },
                { title: t.table.endTime, key: 'endTime', width: 150 },
                { title: t.table.patternHits, key: 'patternHits', align: 'center', width: 120 },
                { title: t.table.hits, key: 'hits', align: 'center', width: 110 },
                { title: t.table.sortOrder, key: 'sortOrder', align: 'center', width: 80, render: renderSortOrder },
                { title: t.table.createBy, key: 'createBy', width: 150, tooltip: true},
                { title: t.table.createTime, key: 'createTime', width: 150 },
                {
                    title: t.table.status,
                    key: 'status',
                    align: 'center',
                    width: 100,
                    render: renderStatus,
                },
                { title: ' ', align: 'center' },
                {
                    title: msgUtil.message.action.name,
                    key: 'action',
                    align: 'center',
                    width: 130,
                    fixed: 'right',
                    render: renderAction,
                },
            ],
            loading: false,
        };
    },
    methods: {
        //排序
        async orderClick(btn) {
            this.formItem.oa = '';
            this.formItem.od = '';
            if (btn.order === 1) {
                this.formItem.oa = btn.key;
            } else if (btn.order === 2) {
                this.formItem.od = btn.key;
            }
            await this.search(true);
        },
        async search(flg) {
            if (flg) {
                this.formItem.current = 1;
                this.$refs.page.currentPage = 1;
            }
            //this.wrapperStartTime();
            this.loading = true;
            let adDto = {};
            adDto.spaceId = this.formItem.spaceId;
            adDto.name = this.formItem.name;
            adDto.pattern = this.formItem.pattern;
            adDto.status = this.formItem.status;
            adDto.oa = this.formItem.oa;
            adDto.od = this.formItem.od;
            adDto.current = this.formItem.current;
            adDto.size = this.formItem.size;
            const result = await getList(adDto);
            if (result !== null) {
                this.data = result.page.records;
                this.total = result.page.total;
            }
            this.loading = false;
        },
        async searchAdSpace() {
            const adSpaces = await getAdSpaceList();
            if (adSpaces.adSpaceList != null) {
                this.adSpaceList = adSpaces.adSpaceList;
            }
        },
        // 页号改变
        async pageChange() {
            this.formItem.current = this.$refs.page.currentPage;
            await this.search(false);
        },
        // 每页显示数据
        async pageSizeChange() {
            this.formItem.size = this.$refs.page.currentPageSize;
            await this.search(false);
        },
        // 删除
        async del(id) {
            await del(id);
            await this.search(true);
        },
        // 批量删除
        async delAll() {
            if (this.selectIds.length === 0) {
                Message.error({
                    content: this.msgUtil.message.warn.notSelectedRow,
                    duration: 60,
                    closable: true,
                });
                return;
            }
            await delAll(this.selectIds);
            await this.search(true);
        },
        // 行选择
        rowSelect(selection) {
            this.selectIds = selection.map(p => {
                return { id: p.id };
            });
        },
    },
    async mounted() {
        await this.searchAdSpace();
        await this.search(true);
    },
};
</script>

<style lan="less" scoped>
</style>
